import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API();

export default {

    getBilety(idKl, size, page, filter) {
        if (filter === undefined){
            filter = '';
        }
        return axios({
            method: 'get',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/auth/bilety/byKlient/' + idKl + AppConfig.V_LOG() + '&size=' + size + '&page=' + page + '&sort=id_bi,desc' + filter,
        });
    },

    getBilet(idBi) {
        return axios({
            method: 'get',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/bilety/' + idBi + AppConfig.V_LOG(),
        });
    },

    getOcena(idKl, idKu) {
        return axios({
            method: 'get',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/auth/bok/oceny/ocena?idKu=' + idKu + '&idKl=' + idKl + AppConfig.V_LOG_SECOND_PARAM(),
        });
    },

    getPlik(idOc) {
        return axios({
            method: 'get',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/auth/bok/oceny/getPliki/' + idOc + AppConfig.V_LOG(),
        });
    },
}



// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/mojeBiletyComponents/BiletyJednorazoweService.js